import { set } from "../toggling";

const TABLE_NAME = "formExclusion";

let cache = {};

export const cacheRows = (rows) => {
	for (const row of rows) cache[row.key] = row;
};

export const syncFlags = (data) => {
	for (const key in cache) {
		const row = data.curData.values.table.formExclusion.list.find(
			(row) => row.key === key,
		);
		if (row) set(TABLE_NAME, data, row, !!cache[key].list[0]);
	}
};

export const pullAllChanges = (rows) => {
	for (const key in cache)
		if (!rows.find((row) => row === key)) rows.push(cache[key]);
};

export const clearCache = () => {
	cache = {};
};

// прокиньте stack в мастер пожалуйста :pray:
window.addEventListener("gr-event", (ev) => {
	if (ev.detail.action === "stack" && ev.detail.type === "back") clearCache();
});
